(ns dashboard.views.settings.account
  (:require
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen copy-text]]
   [dashboard.components.button :refer [button]]
   ["@heroicons/react/outline" :refer [ClipboardCopyIcon]]))

(defn content []
  [:div.divide-y.divide-gray-200
   [:div.py-6.px-4.sm:p-6.lg:pb-8
    [:div.grid.grid-cols-12.gap-6
     [:div.col-span-12.sm:col-span-6
      [:label.block.text-sm.font-medium.text-gray-700
       {:for "refresh-token"}
       "Refresh Token"]
      [:div.flex.items-center
       [:input#first-name.mt-1.block.w-full.border.border-gray-300.rounded-md.shadow-sm.py-2.px-3.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.sm:text-sm
        {:auto-complete "refresh-token"
         :name "refresh-token"
         :type "password"}]
       [:button.ml-5.bg-white.p-2.border.border-gray-300.rounded-md.shadow-sm.text-sm.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500
        {:type "button"
         :on-click #(do
                      (copy-text "test"))}
        [:> ClipboardCopyIcon
         {:class "h-5 w-5"}]]]]]]
   [:div.divide-y.divide-gray-200
    [:div.py-4.px-4.flex.justify-end.sm:px-6
     [button
      {:type "button"}
      (tr :action/save)]]]])
